export class NotRetryableJobQueueError extends Error {
  constructor(message?: string) {
    super(message ?? "Not Retryable Job Queue Error");
    Object.setPrototypeOf(this, NotRetryableJobQueueError.prototype);
  }
}

export class HrisSyncFailedDueToFailedEmployeesError extends NotRetryableJobQueueError {
  constructor() {
    super("HRIS sync failed due to failed employees");
  }
}

export class PostSyncExternalEmployeesError extends NotRetryableJobQueueError {
  constructor(originalError?: Error | string) {
    if (originalError instanceof Error) {
      super(originalError.message);
      this.stack = originalError.stack;
      return;
    }

    super(originalError ?? "HRIS sync failed during POST_SYNC_EXTERNAL_EMPLOYEES");
  }
}
